var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTennis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "80.57 0.2 25.97 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "so-tennis",
    clipPath: "url(#clip0_695_2010)",
    filter: "url(#filter0_dddddd_695_2010)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M105.737 19.4C105.737 20.505 105.405 21.5862 104.781 22.5068C104.157 23.4276 103.269 24.147 102.228 24.5722C101.186 24.9975 100.04 25.1089 98.9336 24.892C97.8274 24.675 96.8129 24.1399 96.0176 23.3558C95.2225 22.5719 94.6823 21.5745 94.4636 20.4904C94.2449 19.4063 94.3571 18.2826 94.7864 17.2607C95.2157 16.2387 95.9436 15.3634 96.8797 14.7467C97.816 14.1299 98.9179 13.8 100.046 13.8C101.559 13.8 103.008 14.3927 104.074 15.4442C105.141 16.4953 105.737 17.9185 105.737 19.4Z",
    fill: "#EEB0FF",
    stroke: "#fff",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M81.4874 18.3653C80.9879 18.8349 80.6723 19.4631 80.5961 20.1394C80.5199 20.8158 80.6879 21.4969 81.0707 22.0632C81.3103 22.3947 81.6202 22.6708 81.979 22.8723C82.3377 23.0738 82.7367 23.1959 83.1481 23.23C83.5595 23.2641 83.9735 23.2094 84.3614 23.0698C84.7492 22.9302 85.1016 22.709 85.3939 22.4216L86.317 21.5128C87.36 20.5672 88.4779 19.7052 89.66 18.9349C90.1137 18.621 90.5844 18.3317 91.0699 18.0683C91.2731 16.7214 91.7854 15.4381 92.568 14.316C93.3505 13.194 94.3825 12.2629 95.5854 11.5938C96.7882 10.9246 98.1302 10.5351 99.5089 10.4548C100.888 10.3746 102.267 10.6058 103.541 11.1307C103.772 10.4975 103.901 9.83221 103.921 9.15952C104.07 6.97453 103.347 4.8187 101.906 3.15226C100.465 1.48582 98.4202 0.440819 96.2084 0.240339C93.9966 0.0398589 91.7929 0.699789 90.0678 2.07924C88.3426 3.4587 87.2328 5.44838 86.9752 7.62352C86.6411 11.2936 85.0495 14.7421 82.4624 17.4014L81.4874 18.3653Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_695_2010",
    x: 0.572266,
    y: 0.199219,
    width: 185.965,
    height: 205.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_695_2010"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.143771 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_695_2010",
    result: "effect2_dropShadow_695_2010"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.119221 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_695_2010",
    result: "effect3_dropShadow_695_2010"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_695_2010",
    result: "effect4_dropShadow_695_2010"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0807786 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_695_2010",
    result: "effect5_dropShadow_695_2010"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0562291 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_695_2010",
    result: "effect6_dropShadow_695_2010"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_695_2010",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_2010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9653,
    height: 25.6,
    fill: "white",
    transform: "translate(80.5723 0.199219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.a56219309a4f8703e1e9316c7eda18a0.svg";
export { ForwardRef as ReactComponent };